import * as React from "react";
import { Offcanvas } from "react-bootstrap";
import "../../sass/_ccModal.scss";

type Props = {
  title?: string;
  show?: boolean;
  onCanvasClose: () => void;
  children: JSX.Element;
  bodyCssClassName: string;
  offCanvasClassName: string;
};

const CCOffcanvas = ({ title, show, onCanvasClose, children, bodyCssClassName, offCanvasClassName }: Props) => {
  return (
    <Offcanvas
      show={show}
      onHide={onCanvasClose}
      scroll={false}
      backdrop
      placement="end"
      className={offCanvasClassName}
    >
      {title && <Offcanvas.Header closeButton className="offcanvas-header">
        <Offcanvas.Title className="offcanvas-title" title={title}>{title}</Offcanvas.Title>
      </Offcanvas.Header>
      }
      <Offcanvas.Body className={bodyCssClassName}>{children}</Offcanvas.Body>
    </Offcanvas>
  );
};

export default CCOffcanvas;
